module.exports = __webpack_public_path__ + "media/MyAudio_4.43666943.mp3";